import { ContentPage } from "../components/layout/ContentPage";
import { ButtonLink } from "../components/ui";
import { getLegalCopy } from "../data/legalPages";
import { useTranslation } from "../i18n";
import { createLocalizedMeta } from "../utils/routeMeta";

export const meta = createLocalizedMeta({
	title: locale => getLegalCopy(locale).contact.metaTitle,
	description: locale => getLegalCopy(locale).contact.metaDescription,
	path: "/contact",
});

export default function ContactPage() {
	const { locale } = useTranslation();
	const copy = getLegalCopy(locale).contact;

	return (
		<ContentPage title={copy.title} subtitle={copy.subtitle}>
			<section className="space-y-5">
				<p>{copy.intro}</p>
				<ButtonLink href={`mailto:${copy.email}`} className="not-prose w-fit">
					{copy.email}
				</ButtonLink>
			</section>

			<section>
				<h2>{copy.acceptedTitle}</h2>
				<p>{copy.acceptedBody}</p>
				<dl className="not-prose mt-6 divide-y divide-border">
					{copy.cards.map(item => (
						<div key={item.label} className="grid gap-2 py-4 sm:grid-cols-[10rem_minmax(0,1fr)] sm:gap-6">
							<dt className="text-sm font-medium text-foreground">{item.label}</dt>
							<dd className="text-sm leading-relaxed text-muted-foreground">{item.value}</dd>
						</div>
					))}
				</dl>
			</section>
		</ContentPage>
	);
}
